module.exports = __webpack_public_path__ + "static/img/coches-small-black.649d626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coches-small-black.png
// module id = 255
// module chunks = 1